import { render, staticRenderFns } from "./ym-overage.vue?vue&type=template&id=63783179&scoped=true&"
import script from "./ym-overage.vue?vue&type=script&lang=js&"
export * from "./ym-overage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63783179",
  null
  
)

export default component.exports